"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var bootstrap_modal_module_1 = require("./bootstrap-modal.module");
exports.BootstrapModalModule = bootstrap_modal_module_1.BootstrapModalModule;
var dialog_component_1 = require("./dialog.component");
exports.DialogComponent = dialog_component_1.DialogComponent;
var dialog_service_1 = require("./dialog.service");
exports.DialogService = dialog_service_1.DialogService;
exports.DialogServiceConfig = dialog_service_1.DialogServiceConfig;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-bootstrap-modal/dist/index.js
// module id = XMV4
// module chunks = 3